import { useCallback } from 'react';
import { useAppStore } from '../../../store';
import type { AvatarItem } from '../types/types';

export function usePaidItems() {
  const { user } = useAppStore();

  
  const isPurchased = useCallback(
    (virtualGoodId?: string) => {
      if (!user?.catalog_items || !virtualGoodId) return false;
      
      try {
        const purchased = Object.keys(user.catalog_items).find((item: any) => {
          return item === virtualGoodId;
        });
        return !!purchased;
      } catch (e) {
                return false;
      }
    },
    [user],
  );

  
  const isItemEnabled = useCallback(
    (item: AvatarItem) => {
      
      if (!item.virtualGoodId) return true;
      
      
      return isPurchased(item.virtualGoodId);
    },
    [isPurchased],
  );

  
  const getPurchasedItems = useCallback(() => {
    if (!user?.catalog_items) return [];
    return Object.keys(user.catalog_items);
  }, [user]);

  return {
    isPurchased,
    isItemEnabled,
    getPurchasedItems,
    userPoints: user?.point_categories,
  };
}
